// extracted by mini-css-extract-plugin
module.exports = {"header":"FalconCardHeader_header__1ve0x","bottomBorder":"FalconCardHeader_bottomBorder__2ESwT"};